import React from 'react'

import Icon from '@/components/common/Icon'

const IconFirstTime: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, height, width }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 6"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9376 0H13.1171L13.2689 3.86772L14.7606 0H16.5292L16.7615 3.86772L18.2621 0H19.2L16.9937 5.67206H14.9839L14.7963 2.46534L13.4565 5.67206H11.3127L10.9376 0Z"
      fill="currentColor"
    />
    <path
      d="M6.95434 0H10.7149L10.572 0.678861H8.74975L8.37459 2.40281H9.90203L9.75911 3.07274H8.23167L7.82078 4.98427H9.64299L9.509 5.67206H5.74847L6.95434 0Z"
      fill="currentColor"
    />
    <path
      d="M4.76096 5.67206H2.67078L1.67929 1.5721L0.803914 5.67206H0L1.20587 0H3.34071L4.27861 4.15355L5.16291 0H5.98469L4.76096 5.67206Z"
      fill="currentColor"
    />
  </svg>
)

export default Icon(IconFirstTime)
